import React, { useState } from 'react';
import { MenuIcon, XIcon, ChevronRightIcon } from 'lucide-react';
import { Link } from 'react-router-dom';
export const HomeHeader = () => {
  const [mobileMenuOpen, setMobileMenuOpen] = useState(false);
  const toggleMobileMenu = () => {
    setMobileMenuOpen(!mobileMenuOpen);
  };
  return <header className="mb-6 sm:mb-10" data-id="element-2544">
      {/* Journal masthead */}
      <div className="border-b-2 border-slate-800 mb-4" data-id="element-2545">
        <div className="flex items-center mb-2" data-id="element-2546">
          <div className="flex-shrink-0 mr-4" data-id="element-2547">
            <img src="https://uploadthingy.s3.us-west-1.amazonaws.com/b3PGU9GV81h1ZaHnnndvQZ/ddEpruXNUzZl9zX8arGEd.png" alt="Top Health Insider" className="h-10" data-id="element-2548" />
          </div>
          <div className="flex-grow" data-id="element-2549">
            <div className="text-xs text-slate-600 uppercase tracking-wider mb-1" data-id="element-2550">
              HOME
            </div>
            <div className="text-xs text-slate-600" data-id="element-2551">
              {(() => {
              const today = new Date();
              const month = today.toLocaleString('en-US', {
                month: 'long'
              }).toUpperCase();
              const day = today.getDate();
              const year = today.getFullYear();
              return `${month} ${day}, ${year}`;
            })()}
            </div>
          </div>
        </div>
      </div>
      {/* Breadcrumbs */}
      <div className="flex items-center text-xs text-slate-500 mb-4" data-id="element-2552">
        <Link to="/" className="hover:text-slate-700 transition-colors" data-id="element-2553">
          Health
        </Link>
        <ChevronRightIcon className="h-3 w-3 mx-1" data-id="element-2554" />
        <Link to="/" className="hover:text-slate-700 transition-colors" data-id="element-2555">
          Women's Health
        </Link>
        <ChevronRightIcon className="h-3 w-3 mx-1" data-id="element-2556" />
        <span className="text-slate-700 font-medium" data-id="element-2557">Home</span>
      </div>
      {/* Navigation */}
      <nav className="mb-6 border-b border-slate-200 pb-4" data-id="element-2558">
        <div className="flex items-center justify-between md:hidden" data-id="element-2559">
          <div className="font-medium text-slate-900 bg-slate-100 px-3 py-1 rounded" data-id="element-2560">
            <Link to="/" data-id="element-2561">Home</Link>
          </div>
          <button className="p-1 rounded-md text-slate-700 hover:bg-slate-100" onClick={toggleMobileMenu} aria-label="Toggle menu" data-id="element-2562">
            {mobileMenuOpen ? <XIcon className="h-6 w-6" data-id="element-2563" /> : <MenuIcon className="h-6 w-6" data-id="element-2564" />}
          </button>
        </div>
        <ul className={`${mobileMenuOpen ? 'flex' : 'hidden'} md:flex flex-col md:flex-row md:items-center space-y-3 md:space-y-0 md:space-x-4 text-sm mt-3 md:mt-0`} data-id="element-2565">
          <li className="font-medium text-slate-900 bg-slate-100 px-3 py-1 rounded hidden md:block" data-id="element-2566">
            <Link to="/" data-id="element-2567">Home</Link>
          </li>
          <li className="text-slate-700 hover:text-slate-900 px-2 py-1" data-id="element-2568">
            <Link to="/menopause" data-id="element-2569">Menopause Solutions</Link>
          </li>
          <li className="text-slate-700 hover:text-slate-900 px-2 py-1" data-id="element-2570">
            <Link to="/adv-1" data-id="element-2571">Vaginal Health</Link>
          </li>
          <li className="text-slate-700 hover:text-slate-900 px-2 py-1" data-id="element-2572">
            <span data-id="element-2573">Hormonal Balance</span>
          </li>
          <li className="text-slate-700 hover:text-slate-900 px-2 py-1" data-id="element-2574">
            <span data-id="element-2575">Sleep & Energy</span>
          </li>
          <li className="text-slate-700 hover:text-slate-900 px-2 py-1" data-id="element-2576">
            <span data-id="element-2577">Research Hub</span>
          </li>
        </ul>
      </nav>
    </header>;
};